import { JsonObject } from "../interface/json";

const d = window as any;
export const commonService = {
  getJsonParams(info: JsonObject): Promise<any> {
    const path = "api/common/jsonParams/get";
    return d.$sk.$skxhrp(path, info);
  },
  getThirdanaly(info) {
    const path = "api/account/thirdanalytics/get";
    return d.$sk.$skxhr(path, info);
  },
  getDomain(info) {
    const path = "api/domain/GetDomain";
    return d.$sk.$skxhr(path, info);
  },
};
